














import Component from 'vue-class-component';

import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import { BaseVue } from '../../BaseVue';
import Users from '../../components/org/UserList.vue';

@Component({
  components: {
    Users,
    UiPageHeader,
  },
})
export default class UsersClass extends BaseVue {
  public selectedTab = 0;
}
